import { useParams } from 'react-router-dom';

import NotFound from '@/components/common/NotFound';

import {
  Table,
  TableBody,
  TableHeader,
  TableHead,
  TableRow,
  TableCell
} from '@/components/ui/table';
import { Card } from '@/components/ui/card';

import { useLocations } from '@/data/location';

const List = () => {
  const params = useParams();
  const locations = useLocations(params.regionId);

  if (locations.data.length === 0) {
    return <NotFound title="No Locations Found" />;
  }

  return (
    <>
      <Card>
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Name</TableHead>
              <TableHead>Tenant</TableHead>
              <TableHead>Address</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {locations.data.map((location) => (
              <TableRow key={location.id}>
                <TableCell className="py-2">{location.name}</TableCell>
                <TableCell className="py-2">{location.tenant.name}</TableCell>
                <TableCell className="py-2">
                  {location.address || '--'}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Card>
      <div className="text-center p-4">
        <span className="text-sm text-muted-foreground">
          Total: {locations.data.length}
        </span>
      </div>
    </>
  );
};

export default List;
